import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/storefront/PageHeader";
import { ProductCard } from "@/components/storefront/ProductCard";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { usePageContent } from "@/context/SiteContext";
import { API, imgUrl } from "@/lib/api";

export default function Weddings() {
  const content = usePageContent("weddings_page");
  const [products, setProducts] = useState([]);

  useEffect(() => {
    API.get("/products", { params: { category: "weddings" } }).then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="weddings-page">
      <Seo title={content?.seo_title} description={content?.seo_description} />
      <PageHeader title={content?.title || "Wedding Flowers"} subtitle={content?.intro} testId="weddings-header" />
      <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-start">
        {content?.image && <img src={imgUrl(content.image)} alt="Wedding flowers" className="rounded-xl aspect-[4/3] object-cover w-full" data-testid="weddings-image" />}
        <div>
          {(content?.body || "").split("\n\n").map((p, i) => (
            <p key={i} className="text-muted-foreground leading-relaxed mb-4">{p}</p>
          ))}
          <Button asChild className="rounded-full mt-2" data-testid="weddings-consultation-btn">
            <Link to="/contact">{content?.cta_label || "Arrange a Consultation"}</Link>
          </Button>
        </div>
      </div>
      {products.length > 0 && (
        <div className="max-w-7xl mx-auto px-4 mt-16" data-testid="weddings-products">
          <h2 className="font-display text-3xl tracking-tight mb-8">Wedding Collection</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        </div>
      )}
    </div>
  );
}
